import styled, { keyframes } from 'styled-components';

export const SkeletonStyled = styled.div<{
  borderRadius?: string;
  maxWidth?: string;
  width?: string;
  height?: string;
}>`
  background: #dddd;
  overflow: hidden;
  margin: 4px 0;
  position: relative;
  border-radius: ${(props) => props.borderRadius || '4px'};
  width: ${(props) => props.width || '100%'};
  max-width: ${(props) => props.maxWidth || '100%'};
  height: ${(props) => props.height || '20px'};
`;

export const ShimmerStyled = styled.div`
  width: 50%;
  height: 100%;
  background: rgba(255, 255, 255, 0.4);
  transform: skewX(-20deg);
  box-shadow: 0 0 30px 30px rgba(255, 255, 255, 0.3);
`;

export const loadingKeyframes = keyframes`
  0% {
    transform: translateX(-150%);
  }
  50% {
    transform: translateX(-60%);
  }
  100% {
    transform: translateX(150%);
  }
`;

export const ShimmerWrapperStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  animation: ${loadingKeyframes} 2.5s infinite;
`;
